/** Date display helpers for history and stats. */

export function formatDate(ts: number): string {
  return new Date(ts).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatTime(ts: number): string {
  return new Date(ts).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
}

/** "just now", "5m ago", "3h ago", "2d ago", else a date. */
export function fromNow(ts: number, now: number = Date.now()): string {
  const diff = now - ts;
  const sec = Math.round(diff / 1000);
  if (sec < 45) return 'just now';
  const min = Math.round(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.round(hr / 24);
  if (day < 7) return `${day}d ago`;
  return formatDate(ts);
}

/** Whole calendar days between two timestamps (local midnight to local midnight). */
export function daysBetween(a: number, b: number): number {
  const startA = new Date(a);
  const startB = new Date(b);
  const ms =
    new Date(startB.getFullYear(), startB.getMonth(), startB.getDate()).getTime() -
    new Date(startA.getFullYear(), startA.getMonth(), startA.getDate()).getTime();
  return Math.round(ms / 86_400_000);
}
